import React, { useLayoutEffect } from 'react';
import { Button, Modal } from 'antd';
import { CompressOutlined } from '@ant-design/icons';
import { formatFileSize, MAX_CLOUDINARY_UPLOAD_BYTES } from '../../utils/imageUpload';
import './CompressionConfirmModal.css';

const COMPRESSION_MODAL_Z_VAR = '--compression-confirm-modal-z';

export default function CompressionConfirmModal({
  open,
  fileSize,
  onCompress,
  onUploadOriginal,
  onCancel,
  zIndex = 2000,
  getContainer = false,
}) {
  const canUploadOriginal = (fileSize || 0) <= MAX_CLOUDINARY_UPLOAD_BYTES;

  useLayoutEffect(() => {
    const root = document.documentElement;
    if (open) {
      root.style.setProperty(COMPRESSION_MODAL_Z_VAR, String(zIndex));
    } else {
      root.style.removeProperty(COMPRESSION_MODAL_Z_VAR);
    }
    return () => {
      root.style.removeProperty(COMPRESSION_MODAL_Z_VAR);
    };
  }, [open, zIndex]);

  return (
    <Modal
      className="ant-modal-confirm ant-modal-confirm-confirm"
      wrapClassName="compression-confirm-modal"
      visible={open}
      onCancel={onCancel}
      getContainer={getContainer}
      zIndex={zIndex}
      width={416}
      title={null}
      closable={false}
      maskClosable={false}
      footer={null}
    >
      <div className="ant-modal-confirm-body-wrapper">
        <div className="ant-modal-confirm-body">
          <CompressOutlined />
          <span className="ant-modal-confirm-title">Large image detected</span>
          <div className="ant-modal-confirm-content">
            {canUploadOriginal ? (
              <span>
                Your image is <strong>{formatFileSize(fileSize || 0)}</strong>. Would you like to
                compress it before uploading for faster performance?
              </span>
            ) : (
              <span>
                Your image is <strong>{formatFileSize(fileSize || 0)}</strong> (over the{' '}
                {formatFileSize(MAX_CLOUDINARY_UPLOAD_BYTES)} upload cap). The original file cannot
                be sent — use compress to upload, or cancel.
              </span>
            )}
          </div>
        </div>
        <div className="ant-modal-confirm-btns compression-confirm-btns">
          <Button onClick={onCancel}>Cancel</Button>
          {canUploadOriginal && <Button onClick={onUploadOriginal}>Upload Original</Button>}
          <Button type="primary" onClick={onCompress}>
            Compress & Upload
          </Button>
        </div>
      </div>
    </Modal>
  );
}
